// extracted by mini-css-extract-plugin
export default {"messageGroupLeft":"MessageGroupLeft_messageGroupLeft__MpTsp","messageListLeft":"MessageGroupLeft_messageListLeft__RO+Ps"};